import { FlatList, Platform } from 'react-native';
import { FlatList as GestureHandlerFlatList } from 'react-native-gesture-handler';

export const ActionSheetFlatList = Platform.select({
  native: GestureHandlerFlatList as unknown as typeof FlatList,
  web: FlatList,
}) as unknown as typeof FlatList;
